import { BaseEdge, type EdgeProps } from '@xyflow/react'

export default function WorkflowMapLoopEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY } = props
  // A smoothstep edge between the two handles of the same card crosses the
  // card itself. Route this declared return above it so the path stays visible.
  const path = `M${sourceX} ${sourceY} C${sourceX + 80} ${sourceY - 140} ${targetX - 80} ${targetY - 140} ${targetX} ${targetY}`
  return <BaseEdge id={props.id} path={path} markerEnd={props.markerEnd} style={props.style}
    label={props.label} labelStyle={props.labelStyle} labelBgStyle={props.labelBgStyle}
    labelX={(sourceX + targetX) / 2} labelY={(sourceY + targetY) / 2 - 105} />
}
